<template>
  <vs-popup class="modify-leave-entitlement" id="popup" :title="'MODIFY LEAVE ENTITLEMENT'"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="modify-leave-entitlement-popup" @submit.prevent="handleSubmit(onClickModifyLeaveEntitlement)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="total_days" name="total_days" rules="required" v-slot="{ errors }">
                <small class="label">Total Days</small>
                <vs-input v-model="form.total_days" class="w-full" name="total_days"></vs-input>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="carried_forward_days" name="carried_forward_days" rules="required" v-slot="{ errors }">
                <small class="label">Carried Forward Days</small>
                <vs-input v-model="form.carried_forward_days" class="w-full" name="carried_forward_days"></vs-input>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row hidden">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="used_days" name="used_days" rules="required" v-slot="{ errors }">
                <small class="label">Used Days</small>
                <vs-input v-model="form.used_days" class="w-full" name="used_days"></vs-input>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row hidden">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="pending_days" name="pending_days" rules="required" v-slot="{ errors }">
                <small class="label">Pending Days</small>
                <vs-input v-model="form.pending_days" class="w-full" name="pending_days"></vs-input>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-ccp-items-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const LeaveRepository = RepositoryFactory.get('leave');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      total_days: '',
      carried_forward_days: '',
      used_days: '',
      pending_days: '',
    },
  }
}

export default {
  name: 'UpdateLeaveEntitlementPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.id = id
        await this.fetchLeaveEntitlementDetails()
        this.open = true;
      } catch (error) {

      }
    },
    async fetchLeaveEntitlementDetails() {
      try {
        const { data } = (await LeaveRepository.getStaffLeaveEntitlementDetails(this.id)).data
        this.form = {
          total_days: data.total_days,
          carried_forward_days: data.carried_forward_days,
          used_days: data.used_days,
          pending_days: data.pending_days
        }
      } catch (error) {
        
      }
    },
    async onClickModifyLeaveEntitlement() {
      const vue = this;
      await this.$vs.loading({
        container: '#modify-leave-entitlement-popup',
        scale: 0.45
      })
      try {
        await LeaveRepository.modifyLeaveEntitlement(this.id, this.form);
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#modify-leave-entitlement-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#modify-leave-entitlement-popup > .con-vs-loading')
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.modify-leave-entitlement>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}
</style>